import Typed from 'typed.js';
import style_vars from '../StyleVariables';
import {throttle} from 'throttle-debounce';

function typewriter(el) {

  let opts;

  // item_settings()
  // -------------------------------------

  function item_settings() {
    opts = {
      strings_el: null,
      strings_el_id: null,
      init_immediately: false,
      init_after: 1000,
      bp_min: null,
      bp_max: null,
      inital_state_el: null,
      initial_state_strings_el: null,
      initalized: false,
      typed_instance: null,
      destroyed: false,
    };


    // set_opt() - && set options object
    // -------------------------------------

    function set_opt(opt_name, attr, callback = null) {
      if (el.hasAttribute(attr)) {
        opts[opt_name] = callback ? callback(el.getAttribute(attr)) : el.getAttribute(attr);
      }
    }
    set_opt('strings_el_id',    'data-js-typewriter-strings-el-id');
    set_opt('init_immediately', 'data-js-typewriter-init-immediately');
    set_opt('init_after',       'data-js-typewriter-init-after', parseInt);
    set_opt('bp_min',           'data-js-typewriter-bp-min');
    set_opt('bp_max',           'data-js-typewriter-bp-max');

    opts.strings_el = document.getElementById(opts.strings_el_id);
  }


  // store_inital_state(()
  // -------------------------------------

  function store_inital_state() {
    opts.initial_state_strings_el = opts.strings_el.innerHTML;
    opts.inital_state_el = el.innerHTML;
  }


  // reset_to_inital_state()
  // -------------------------------------

  function reset_to_inital_state() {
    opts.initalized = false;
    el.innerHTML = opts.inital_state_el;
    opts.strings_el.innerHTML = opts.initial_state_strings_el;
  }


  // bp_acitve()
  // -------------------------------------

  function bp_active() {
    let bp_is_active = false;
    if (opts.bp_max) {
      bp_is_active = window.matchMedia(`(max-width:${style_vars.bp_max[opts.bp_max]})`).matches;
    }
    if (opts.bp_min) {
      bp_is_active = window.matchMedia(`(min-width:${style_vars.bp_min[opts.bp_min]})`).matches;
    }
    return bp_is_active;
  }


  // type()
  // -------------------------------------

  function type() {
    if (opts.initalized) {
      return false;
    }
    opts.initalized = true;

    if (opts.init_immediately) {
      call_typed(el);
    }

    if (opts.init_after) {
      setTimeout(() => {
        call_typed(el);
      }, opts.init_after);
    }
  }


  // call_typed()
  // -------------------------------------

  function call_typed(el) {
    if (opts.typed_instance) {
      return false;
    }
    opts.typed_instance = new Typed(el, {
      stringsElement: opts.strings_el,
      typeSpeed: 70,
      backSpeed: 70,
      backDelay: 500,
      loop:      true,
    });
  }


  // type_when_bp_active()
  // -------------------------------------

  function type_when_bp_active() {
    if (bp_active()) {
      type();
    }
    else {
      if (opts.initalized && opts.typed_instance) {
        opts.typed_instance.destroy();
        opts.typed_instance = null;
        reset_to_inital_state();
      }
    }
  }


  // type_when_bp_active__throttled
  // -------------------------------------

  const type_when_bp_active__throttled = throttle(30, type_when_bp_active);


  // init()
  // -------------------------------------

  function init() {
    item_settings();
    store_inital_state();

    if (!opts.strings_el) {
      return false;
    }

    if (opts.bp_min || opts.bp_max) {
      window.addEventListener('resize', type_when_bp_active__throttled);
      type_when_bp_active();
    }
    else {
      type();
    }
  }
  init();
}


function init_all() {
  const items = Array.from(document.querySelectorAll('[data-js-typewriter]'));
  items.forEach(typewriter);
}
init_all();
